module.exports = __webpack_public_path__ + "static/img/djkx7.3b7f43e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/djkx7.jpeg
// module id = ar5X
// module chunks = 1